<template>
    <div class="ticket-packages-price">
        <small class="from" v-if="from"
            >{{ trans.from }}: <span>{{ from }}</span></small
        >
        <span class="price">
            <small class="to" v-if="from">{{ trans.to }}:</small>
            {{ price }}
        </span>
    </div>
</template>

<style lang="scss" scoped>
@import "../../../../sass/variables";

.ticket-packages-price {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    font-size: 21px;
    font-weight: 700;
    color: $color2-primary;
    line-height: 1.5;
    padding: 4px 0;
}

.from,
.to {
    font-size: 13px;
    font-weight: 500;
    color: $color2-text-secondary;
}

.from span {
    text-decoration: line-through;
}
</style>

<script>
export default {
    props: {
        from: {
            type: String,
            required: false
        },
        price: {
            type: String,
            required: true
        },
        trans: {
            type: Object,
            required: true
        }
    }
};
</script>
